import { put } from "../../../common/api/apiShared.ts";
import { CustomFieldValue } from "../../../contract/contract/Contract.types.ts";
import { ajaxQueue } from "../../../common/api/ajaxQueue.ts";

// The entity handed in is a shallow copy of the cached one, so the array must be replaced rather than changed in
// place - otherwise the cache changes along with it and the write looks like a no-op.
export function applyCustomFieldValue(entity: { customFieldValues?: Array<CustomFieldValue> }, customInputFieldId: string, value: any) {
    const currentValues = entity.customFieldValues ?? [];
    const changedValue = { customInputFieldId: customInputFieldId, value: value };
    const isExistingField = currentValues.some((x) => x.customInputFieldId == customInputFieldId);

    entity.customFieldValues = isExistingField
        ? currentValues.map((x) => (x.customInputFieldId == customInputFieldId ? changedValue : x))
        : [...currentValues, changedValue];
}

export function useCustomField(entityApiPath: string, entityId: string, customInputFieldId: string, onChange: (changeFunc: (entity: any) => void) => void) {
    const onFieldChange = (value: any) => {
        // The create dialogs render these fields before the entity exists, so there is nothing to update
        // yet - the value is collected in local state and sent along with the create request instead.
        if (entityId) {
            // Serialize saves per entity so concurrent edits on the same field don't race and insert duplicate
            // rows for the same (entityId, customInputFieldId) pair.
            const queue = ajaxQueue(entityApiPath + entityId);
            queue.addRequest(updateTextFieldApi, value);
        }

        onChange((c) => applyCustomFieldValue(c, customInputFieldId, value));
    };

    function updateTextFieldApi(value: any) {
        return put<CustomFieldValue>(`/${entityApiPath}/${entityId}/custom-fields/${customInputFieldId}`, {
            value: value,
        });
    }

    return {
        onFieldChange,
    };
}
